module.exports = __webpack_public_path__ + "fonts/alimama.d3778deb.otf";